















































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPopover, BvEvent } from "bootstrap-vue";
import { formatPhone } from "@/utils";
import { getDate } from '@/services/timezone';
import { ScheduleLogEntry } from "@/store/modules/types";
import { ScheduleLogType } from "@/store/modules/enums";

@Component({
    components: {
        BPopover,
    },
    computed: mapState("schedule", ["list", "apptComments"]),
    // computed: mapGetters("schedule", ["checkedRows", "notRemindedRows"]),
})
export default class MessagesPopover extends Vue {
    @Prop(Boolean) readonly show!: boolean;
    id = "messages-popover";
    apptComments!: any;
    list!: any;
    loading = false;
    getDate = getDate;
    get target() {
        return this.id + "-target";
    }
    markAllRead() {
        this.$modal.show("dialog", {
            title: "MARK  <b>ALL </b> AS READ",
            text: "Are you sure?",
            buttons: [
                {
                    title: "Yes",
                    handler: async () => {
                        this.$modal.hide("dialog");
                        this.loading = true;
                        try {
                            const comments = this.apptComments.list;
                            for (let i = 0; i < comments.length; i++) {
                                const comment = comments[i];
                                try {
                                    this.markRead(comment, false);
                                } catch (error) {
                                    console.log(error);
                                }
                            }
                            this.refreshMessages();
                        } catch (error) {
                            console.log(error);
                        } finally {
                            this.loading = false;
                        }
                    },
                },
                {
                    title: "No",
                    default: true,
                },
            ],
        });
    }
    async markRead(comment, refresh = true) {
        try {
            await this.$store.dispatch(
                "schedule/markLogRead", comment.id
            );
            if (refresh) {
                this.refreshMessages();
            }
            this.updateAppt(comment);
        } catch (error) {
            console.log(error);
        }
    }
    async saveMessage(message) {
        if (!message.officeMessage) return;

        this.loading = true;
        const entry: ScheduleLogEntry = {
            apptId: message.scheduleId,
            typeId: ScheduleLogType.OFFICE_TO_PATIENT_COMMENT,
            comment: message.officeMessage,
        };
        try {
            await this.$store.dispatch("schedule/saveLog", entry);
            this.markRead(message);
        } catch (error) {
            this.loading = false;
            console.log(error);
        } finally {
            this.loading = false;
        }
    }

    async refreshMessages() {
        try {
            await this.$store.dispatch("schedule/getApptComments", {});
        } catch (error) {
            console.log(error);
        }
    }

    updateAppt(comment) {
        this.list.pageRows.filter(function (appt) {
            if (comment.scheduleId == appt.id)
                appt.hasComments = false;

        })
    }

    formatText(text) {
        return text.replace(/(?:\*)(?:(?!\s))((?:(?!\*|\n).)+)(?:\*)/g, '<b>$1</b>')
            .replace(/(?:_)(?:(?!\s))((?:(?!\n|_).)+)(?:_)/g, '<i>$1</i>')
            .replace(/(?:~)(?:(?!\s))((?:(?!\n|~).)+)(?:~)/g, '<s>$1</s>')
            .replace(/(?:--)(?:(?!\s))((?:(?!\n|--).)+)(?:--)/g, '<u>$1</u>')
            .replace(/(?:```)(?:(?!\s))((?:(?!\n|```).)+)(?:```)/g, '<tt>$1</tt>')
            .replace(/\n|\r/g, "<br>");
    }

    getComment(comment, quoted = false) {

        var _comment = comment.split("|");
        if (quoted) {
            return _comment.length > 1 ? _comment[1] : "";
        } else {
            return _comment[0];
        }

    }

    showReply(message) {
        message.reply = !message.reply;
        this.$forceUpdate();
    }

    showApptInfo(message) {
        message.showApptInfo = !message.showApptInfo;
        this.$forceUpdate();
    }

    close() {
        if (this.loading) return;
        this.$root.$emit("bv::hide::popover", this.id);
        this.$emit('set-blink', true)
    }
    hide(e: BvEvent) {
        if (this.loading) e.preventDefault();
    }

    onShow() {
        this.$emit('set-blink', false)
        console.log("onShow");
    }
    get formatPhone() {
        return formatPhone;
    }
    mounted() { }
}
